import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { Absence, AddRemoveAbsences } from "../types/scheduling/absence";
import { api, schedulingPath } from "./api";
import QueryKeys from "./queryKeys";

class AbsenceAPI {
  static base = schedulingPath("/absence");

  async get(smpw = false): Promise<Absence[]> {
    return api.get(AbsenceAPI.base + `${smpw ? "/smpw" : ""}`).json();
  }

  async save(absence: Absence): Promise<Absence> {
    const url = absence.id ? `${AbsenceAPI.base}/${absence.id}` : AbsenceAPI.base;
    const method = absence.id ? "put" : "post";
    return api(url, { json: absence, method }).json();
  }

  async delete(absence: Absence) {
    await api.delete(`${AbsenceAPI.base}/${absence.id}`);
  }

  async addRemoveBulk(input: AddRemoveAbsences, smpw = false) {
    await api.put(AbsenceAPI.base + `${smpw ? "/smpw" : ""}`, { json: input });
  }
}

export function useAbsence(smpw = false, options?: UseQueryOptions<Absence[], Error>) {
  return useQuery({
    queryKey: [QueryKeys.Absences, smpw],
    queryFn: () => absenceApi.get(smpw),
    ...options,
  });
}

export const absenceApi = new AbsenceAPI();
